// extracted by mini-css-extract-plugin
export default {"root":"CounterItem_root__dRRJK","value":"CounterItem_value__A4hnK"};